<template>
    <button
        v-tippy="t('editorToggleHeaderColumn')"
        :class="[buttonState(editor.can().toggleHeaderColumn()), 'flex-none rounded p-1 text-sm']"
        :disabled="!editor.can().toggleHeaderColumn()"
        @click="editor.chain().focus().toggleHeaderColumn().run()"
    >
        <MdiTableColumn class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiTableColumn from 'materialdesignicons-vue3/icons/MdiTableColumn.js';

    defineExpose({
        name: 'TableToggleHeaderColumnButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
